__turbopack_context__.v({
  "chatSpecialist": "yeWoaW_chatSpecialist",
  "ctaStack": "yeWoaW_ctaStack",
  "midPanel": "yeWoaW_midPanel",
  "midPanelPhone": "yeWoaW_midPanelPhone",
  "midPanelPhonePrice": "yeWoaW_midPanelPhonePrice",
  "midPanelPhoneRight": "yeWoaW_midPanelPhoneRight",
  "midPanelPhoneRow": "yeWoaW_midPanelPhoneRow",
  "offerIcon": "yeWoaW_offerIcon",
  "offerIcons": "yeWoaW_offerIcons",
  "root": "yeWoaW_root",
  "subtitleTextBtn": "yeWoaW_subtitleTextBtn",
  "taxDisclaimer": "yeWoaW_taxDisclaimer",
  "totalPriceSingle": "yeWoaW_totalPriceSingle",
  "tradeInCredit": "yeWoaW_tradeInCredit",
});
